// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.main {
  background: #040404;
  height: 100%;
  width: 100%;
}

.welcome {
  color: greenyellow;
  font-weight: bolder;
  font-size: x-large;
  font-style: italic;
}

.table {
  border-collapse: collapse;
  border: 1px solid #9E9E9E;
}

.th {
  border: 1px solid #9E9E9E;
  color: #FFC107;
}
.td {
  border: 1px solid #9E9E9E;
}

.table.a {
  table-layout: auto;
  width: 180px;
}

.table.b {
  table-layout: fixed;
  width: 180px;
}

.table.c {
  table-layout: auto;
  width: 100%;
}

.table.d {
  table-layout: fixed;
  width: 100%;
}

body {
  font-family: Arial;
  color: white;
}
.nav-bar {
  height: 50px;
  background: #607D8B;
}
.nav-header {
  position: absolute;
  left: 5%;
  text-align: center;
  color: #FFC107;
  margin: 8px;
}
.nav-section {
  margin-left: 95%;
}
.nav-button {
  margin-top: 12px;
  border-radius: 10px;
  background: #FF9800;
  cursor: pointer;
}
.inventory {
  margin-top: 50px;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  overflow-x: hidden;
  padding-top: 20px;
  background-color: #5f5d5d;
}
.split {
  margin-top: 50px;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  overflow-x: hidden;
  padding-top: 20px;
}

.left {
  width: 20%;
  left: 0;
  background-color: #5f5d5d;
}

.right {
  width: 80%;
  right: 0;
  background-color: rgba(25, 17, 8, 0.83);
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.headers {
  margin-right: 40%;
  margin-left: 40%;
  border-radius: 10px;
  background: #607D8B;
  text-align: center;
  color: #FFC107;
  font-size: x-large;
}

.side-panel {
  position: absolute;
  top: 100px;
  /*margin-left: 50%;*/
  /*margin-right: 5px;*/
  /*transform: translate(-50%, -50%);*/
  text-align: center;
  width: 100%;
}

.centered img {
  width: 150px;
  border-radius: 50%;
}

.error {
  color: red;
  font-size: small;
}
.warning {
  color: orange;
  font-size: small;
}
.button {
  border-color: #f7fafb;
  background: #8BC34A;
  margin: 2px;
  cursor: pointer;
  border-radius: 8px;
}
.side-button {
  width: 100%;
  /*border-color: #f7fafb;*/
  background: #607D8B;
  cursor: pointer;
  margin: 2px;
  border-radius: 12px;
  font-style: italic;
  font-weight: bold;
  border-width: 1px;
}

.side-button-active {
  width: 100%;
  background: rgba(25, 17, 8, 0.83);
  cursor: pointer;
  margin: 2px;
  border-radius: 12px;
  font-style: italic;
  color: green;
  /*border-color: green;*/
  font-weight: bold;
  border-width: 1px;
}
.delete-button {
  border-color: #f7fafb;
  background: #c37042;
  margin: 2px;
  cursor: pointer;
  border-radius: 12px;
}

button:hover {
  background: #c5c58a
}
button:disabled {
  cursor: not-allowed;
}

.delete-button:hover {
  background: #c5c58a
}
.side-button:hover {
  background: #c5c58a
}
.side-button-active:hover {
  background: #c5c58a
}
.header {
  color: #00BCD4;
  margin-bottom: 0;
}
.search {
  width: 90%;
  margin: 6px;
  border-radius: 4px;
  border-color: #f9f7f7;
}

.input {
  margin: 2px;
  border-block-start-color: grey;
}

.info {
  color: #00BCD4;
  font-size: small;
  margin-bottom: 0;
}

.price {
  width: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;AACF;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".App {\n  text-align: center;\n}\n\n.main {\n  background: #040404;\n  height: 100%;\n  width: 100%;\n}\n\n.welcome {\n  color: greenyellow;\n  font-weight: bolder;\n  font-size: x-large;\n  font-style: italic;\n}\n\n.table {\n  border-collapse: collapse;\n  border: 1px solid #9E9E9E;\n}\n\n.th {\n  border: 1px solid #9E9E9E;\n  color: #FFC107;\n}\n.td {\n  border: 1px solid #9E9E9E;\n}\n\n.table.a {\n  table-layout: auto;\n  width: 180px;\n}\n\n.table.b {\n  table-layout: fixed;\n  width: 180px;\n}\n\n.table.c {\n  table-layout: auto;\n  width: 100%;\n}\n\n.table.d {\n  table-layout: fixed;\n  width: 100%;\n}\n\nbody {\n  font-family: Arial;\n  color: white;\n}\n.nav-bar {\n  height: 50px;\n  background: #607D8B;\n}\n.nav-header {\n  position: absolute;\n  left: 5%;\n  text-align: center;\n  color: #FFC107;\n  margin: 8px;\n}\n.nav-section {\n  margin-left: 95%;\n}\n.nav-button {\n  margin-top: 12px;\n  border-radius: 10px;\n  background: #FF9800;\n  cursor: pointer;\n}\n.inventory {\n  margin-top: 50px;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  overflow-x: hidden;\n  padding-top: 20px;\n  background-color: #5f5d5d;\n}\n.split {\n  margin-top: 50px;\n  height: 100%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  overflow-x: hidden;\n  padding-top: 20px;\n}\n\n.left {\n  width: 20%;\n  left: 0;\n  background-color: #5f5d5d;\n}\n\n.right {\n  width: 80%;\n  right: 0;\n  background-color: rgba(25, 17, 8, 0.83);\n}\n\n.centered {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.headers {\n  margin-right: 40%;\n  margin-left: 40%;\n  border-radius: 10px;\n  background: #607D8B;\n  text-align: center;\n  color: #FFC107;\n  font-size: x-large;\n}\n\n.side-panel {\n  position: absolute;\n  top: 100px;\n  /*margin-left: 50%;*/\n  /*margin-right: 5px;*/\n  /*transform: translate(-50%, -50%);*/\n  text-align: center;\n  width: 100%;\n}\n\n.centered img {\n  width: 150px;\n  border-radius: 50%;\n}\n\n.error {\n  color: red;\n  font-size: small;\n}\n.warning {\n  color: orange;\n  font-size: small;\n}\n.button {\n  border-color: #f7fafb;\n  background: #8BC34A;\n  margin: 2px;\n  cursor: pointer;\n  border-radius: 8px;\n}\n.side-button {\n  width: 100%;\n  /*border-color: #f7fafb;*/\n  background: #607D8B;\n  cursor: pointer;\n  margin: 2px;\n  border-radius: 12px;\n  font-style: italic;\n  font-weight: bold;\n  border-width: 1px;\n}\n\n.side-button-active {\n  width: 100%;\n  background: rgba(25, 17, 8, 0.83);\n  cursor: pointer;\n  margin: 2px;\n  border-radius: 12px;\n  font-style: italic;\n  color: green;\n  /*border-color: green;*/\n  font-weight: bold;\n  border-width: 1px;\n}\n.delete-button {\n  border-color: #f7fafb;\n  background: #c37042;\n  margin: 2px;\n  cursor: pointer;\n  border-radius: 12px;\n}\n\nbutton:hover {\n  background: #c5c58a\n}\nbutton:disabled {\n  cursor: not-allowed;\n}\n\n.delete-button:hover {\n  background: #c5c58a\n}\n.side-button:hover {\n  background: #c5c58a\n}\n.side-button-active:hover {\n  background: #c5c58a\n}\n.header {\n  color: #00BCD4;\n  margin-bottom: 0;\n}\n.search {\n  width: 90%;\n  margin: 6px;\n  border-radius: 4px;\n  border-color: #f9f7f7;\n}\n\n.input {\n  margin: 2px;\n  border-block-start-color: grey;\n}\n\n.info {\n  color: #00BCD4;\n  font-size: small;\n  margin-bottom: 0;\n}\n\n.price {\n  width: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
